export default __webpack_public_path__ + "static/media/main-bar-group.e469c19c.png";